export const REPORT_START_DATE_STORAGE = 'REPORT_START_DATE_STORAGE'
export const REPORT_END_DATE_STORAGE = 'REPORT_END_DATE_STORAGE'



export const startDateFunc=(start)=>(dispatch)=>{
    dispatch({
        type:REPORT_START_DATE_STORAGE,
        payload:start
    })
}


export const endDateFunc=(end)=>(dispatch)=>{
    dispatch({
        type:REPORT_END_DATE_STORAGE,
        payload:end
    })
}


